import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import LimaHeader from "../components/LimaHeader";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, PhoneCall, Mail, Clock, ShieldCheck, MessageCircle } from "lucide-react";
import { LIMA_CONSULTANT_DISPLAY, buildWaLink } from "../lib/config";

export default function Concluido() {
  const { diagId } = useParams();
  const nav = useNavigate();
  const [diag, setDiag] = useState(null);

  useEffect(() => {
    api.get(`/diagnostics/${diagId}`)
      .then(r => setDiag(r.data))
      .catch(() => nav("/dashboard"));
  }, [diagId, nav]);

  return (
    <div className="min-h-screen bg-[#f4f6f8]">
      <LimaHeader />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(16,36,63,0.15)]">
          <div className="bg-gradient-to-br from-[#10243f] to-[#19385e] text-white p-10 relative">
            <div className="absolute inset-0 grid-bg opacity-20" />
            <div className="relative flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-[#c7a45a] flex items-center justify-center shrink-0">
                <CheckCircle2 size={32} className="text-[#10243f]" />
              </div>
              <div>
                <span className="text-[11px] tracking-[0.28em] font-bold text-[#c7a45a]">STATUS</span>
                <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter mt-1">
                  Diagnóstico Concluído
                </h1>
              </div>
            </div>
          </div>

          <div className="p-10 space-y-6">
            <p className="text-lg text-slate-700 leading-relaxed">
              Recebemos o seu checklist e ele já está protocolado em nosso sistema.
              Um <strong className="text-[#10243f]">consultor Lima SST</strong> irá revisar
              todas as respostas, cruzá-las com as NRs aplicáveis ao seu CNAE e preparar
              uma <strong className="text-[#10243f]">análise detalhada personalizada</strong> —
              incluindo o mapa de exposição legal e o plano de mitigação priorizado.
            </p>

            <div className="grid sm:grid-cols-3 gap-4 pt-2">
              <div className="border border-slate-200 rounded-lg p-4">
                <PhoneCall className="text-[#c7a45a] mb-2" size={20} />
                <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Contato ativo</div>
                <div className="text-sm text-slate-700 mt-1">Um consultor entrará em contato em breve.</div>
              </div>
              <div className="border border-slate-200 rounded-lg p-4">
                <Clock className="text-[#c7a45a] mb-2" size={20} />
                <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Prazo</div>
                <div className="text-sm text-slate-700 mt-1">Retorno em até 2 dias úteis.</div>
              </div>
              <div className="border border-slate-200 rounded-lg p-4">
                <ShieldCheck className="text-[#c7a45a] mb-2" size={20} />
                <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Dados seguros</div>
                <div className="text-sm text-slate-700 mt-1">Respostas salvas para análise técnica.</div>
              </div>
            </div>

            <div className="bg-[#c7a45a]/10 border-l-4 border-[#c7a45a] p-5 rounded-r-lg" data-testid="concluido-message">
              <p className="text-sm text-slate-800 leading-relaxed">
                <strong className="text-[#10243f]">Importante:</strong> este é um instrumento
                de triagem. A análise definitiva — com apontamento de riscos, exposição a
                autuações e plano de conformidade — será apresentada pelo consultor Lima SST,
                que fará contato para agendar a devolutiva.
              </p>
            </div>

            {diag && (
              <div className="text-xs text-slate-400 pt-4 border-t border-slate-100 flex flex-wrap justify-between gap-2">
                <span>Protocolo: <span className="font-mono">{diag.id}</span></span>
                <span>Registrado em {new Date(diag.created_at).toLocaleString("pt-BR")}</span>
              </div>
            )}

            <div className="flex flex-wrap gap-3 pt-4">
              <a
                href={buildWaLink(null, `Olá! Acabei de finalizar meu diagnóstico Lima SST (protocolo ${diag?.id?.slice(0,8) || ""}). Gostaria da devolutiva.`)}
                target="_blank"
                rel="noreferrer"
                data-testid="concluido-whatsapp"
                className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold px-5 py-2.5 rounded-md transition-colors"
              >
                <MessageCircle size={18} /> Falar com o consultor Lima
              </a>
              <Button
                className="bg-[#10243f] hover:bg-[#19385e] text-white"
                onClick={() => nav("/dashboard")}
                data-testid="concluido-dashboard"
              >
                Voltar ao painel
              </Button>
              <Button
                variant="outline"
                className="border-slate-300"
                onClick={() => window.print()}
                data-testid="concluido-print"
              >
                Imprimir comprovante
              </Button>
            </div>
            <p className="text-xs text-slate-400 pt-2">
              Ou entre em contato diretamente pelo WhatsApp {LIMA_CONSULTANT_DISPLAY}.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
